import { api } from '../../plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const getDefaultState = () => {
	return {
		demandeInscription: {
			id: null,
			pp: null,
			validerLaDemande: false,
			retraitVolontaire: false,
			demandeTerminee: false,
			recapitulatif: null,
			accesFormulairePremiereInscription: false,
			accesFormulaireRenouvellement: false,
			accesFormulaireDemission: false,
		}
	}
}

const state = getDefaultState()

const getters = {
	GET_CONTACTID: (state) => { return state.demandeInscription.pp },
	GET_DEMANDEINSCRIPTIONID: (state) => { return state.demandeInscription.id },
	GET_RECAPITULATIF: (state) => { return state.demandeInscription.recapitulatif },
	IS_VALIDEE: (state) => { return state.demandeInscription.validerLaDemande },
	IS_DEMANDE_TERMINEE: (state) => { return state.demandeInscription.demandeTerminee },
	IS_RETRAIT_VOLONTAIRE: (state) => { return state.demandeInscription.retraitVolontaire },
	GET_ACCES_FORMULAIRE_PREMIERE_INSCRIPTION: (state) => { return state.demandeInscription.accesFormulairePremiereInscription },
	GET_ACCES_FORMULAIRE_RENOUVELLEMENT: (state) => { return state.demandeInscription.accesFormulaireRenouvellement },
	GET_ACCES_FORMULAIRE_DEMISSION: (state) => { return state.demandeInscription.accesFormulaireDemission },
}

const mutations = {
	SET_ID(state, id) {
		state.demandeInscription.id = id
	},
	SET_CONTACTID(state, id) {
		state.demandeInscription.pp = id
	},
	SET_VALIDERLADEMANDE(state, value) {
		state.demandeInscription.validerLaDemande = value
	},
	SET_RETRAITVOLONTAIRE(state, value) {
		state.demandeInscription.retraitVolontaire = value
	},
	SET_DEMANDETERMINEE(state, value) {
		state.demandeInscription.demandeTerminee = value
	},
	SET_RECAPITULATIF(state, value) {
		state.demandeInscription.recapitulatif = value
	},
	SET_ACCES_FORMULAIRE_PREMIERE_INSCRIPTION(state, value) {
		state.demandeInscription.accesFormulairePremiereInscription = value
	},
	SET_ACCES_FORMULAIRE_RENOUVELLEMENT(state, value) {
		state.demandeInscription.accesFormulaireRenouvellement = value
	},
	SET_ACCES_FORMULAIRE_DEMISSION(state, value) {
		state.demandeInscription.accesFormulaireDemission = value
	},
	resetState(state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async createDemandeInscription({ commit }, payload) {
		const response = await api.post(`contacts/${payload.contactEncryptedId}/demandesinscriptions`, payload.typeInscription);
		commit('SET_ID', response.data ? response.data : null);
		return response.data
	},
	async validerLaDemandeInscription({ commit }) {
		const response = await api.put(`demandesinscriptions/${state.demandeInscription.id}/valider`)
		commit('SET_VALIDERLADEMANDE', true)
	},
	async retraitVolontaire({ commit }) {
		const response = await api.put(`demandesinscriptions/${state.demandeInscription.id}/retrait-volontaire`)
		commit('SET_RETRAITVOLONTAIRE', true)
	},
	async demandeTerminee({ commit }) {
		const response = await api.put(`demandesinscriptions/${state.demandeInscription.id}/demande-terminee`)
		commit('SET_DEMANDETERMINEE', true)
	},
	async demission({ commit }, champsDemission) {
		await api.put(`demandesinscriptions/${state.demandeInscription.id}/demission`, champsDemission)
	},
	async fetchDemandeInscription({ commit }, demandeInscriptionId) {
		const response = await api.get(`demandesinscriptions/${demandeInscriptionId}`)
		commit('SET_ID', response.data.id)
		commit('SET_CONTACTID', response.data.pp)
		commit('SET_VALIDERLADEMANDE', response.data.validerLaDemande)
		commit('SET_RETRAITVOLONTAIRE', response.data.retraitVolontaire)
		commit('SET_DEMANDETERMINEE', response.data.demandeTerminee)
	},
	async getRecapPaiement({ commit }) {
		const response = await api.get(`/demandesinscriptions/${state.demandeInscription.id}/recapitulatif`);
		commit('SET_RECAPITULATIF', response.data ? response.data : "");
	},
	async getContactAccesFormulaires({ commit }, contactEncryptedId) {
		const response = await api.get(`contacts/${contactEncryptedId}/acces-formulaires`)
		if(response && response.data) {
			commit('SET_ACCES_FORMULAIRE_PREMIERE_INSCRIPTION', response.data.activerFormulairePremiereInscription)
			commit('SET_ACCES_FORMULAIRE_RENOUVELLEMENT', response.data.activerFormulaireRenouvellement)
			commit('SET_ACCES_FORMULAIRE_DEMISSION', response.data.activerFormulaireDemission)
		}
	},
	resetModuleState({ commit }) {
		commit('resetState')
	},

}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions,
})